import React from "react";
import { useNavigate } from "react-router-dom";
import { truncateWords } from "../exports/functions";
import { marked } from "marked";
import { useCompanyDetailsContext } from "../context/CompanyDetailsContext";

const SearchSection = ({ results, query }) => {
  const navigate = useNavigate();

  const handleClick = (section, path, id) => {
    if (
      section === "studentlife" ||
      section === "faculty" ||
      section === "gallery" ||
      section === "tiles" ||
      section === "objective"
    ) {
      navigate(path, {
        state: { section: `${section}${id}` },
      });
    } else {
      navigate(path, {
        state: { section: section },
      });
    }
  };
  const { companyDetailsData } = useCompanyDetailsContext();

  const staticDataMap = {
    email: companyDetailsData[0]?.email,
    address: companyDetailsData[0]?.company_address,
    phone: `${companyDetailsData[0]?.phone_number1 || ""}, ${
      companyDetailsData[0]?.phone_number2 || ""
    }`,
  };

  const staticLabelMap = {
    email: "Email",
    address: "Address",
    phone: "Phone Number",
    admission: "Admission Enquiry",
  };
  const staticKeys = ["email", "address", "phone", "admission"];
  const lowerQuery = query.toLowerCase();

  const matchedKey = staticKeys.find(
    (key) =>
      key.includes(lowerQuery) ||
      staticLabelMap[key].toLowerCase().includes(lowerQuery),
  );

  const isStaticMatch = Boolean(matchedKey);
  const totalResults = results.length + (isStaticMatch ? 1 : 0);

  return (
    <>
      <section className="contact py-120" style={{ overflow: "hidden" }}>
        <div className="container">
          <div className="section-heading text-center">
            <div className="flex-align d-inline-flex gap-8 mb-16">
              <h2 className="mb-24">
                Results for "<em>{query}</em>" ({totalResults})
              </h2>
            </div>
          </div>
          <div className="row gy-4">
            {isStaticMatch && (
              <div className="col-xl-4 col-md-6">
                <div className="bg-main-25 border border-neutral-30 rounded-12 px-32 py-40 d-flex align-items-start gap-24 transition-2 hover-border-main-600">
                  <div className="flex-grow-1">
                    {/* <div className="flex-align d-inline-flex gap-8 mb-16 wow bounceInDown">
                      <h5 className="text-main-600 mb-0">
                        {staticLabelMap[matchedKey]}
                      </h5>
                    </div> */}
                    <h2 className="mb-24 wow bounceInRight">
                      {truncateWords(staticLabelMap[matchedKey] || "", 3)}
                    </h2>
                    <p className="text-neutral-500 text-line-2 wow bounceInUp">
                      {truncateWords(staticDataMap[matchedKey] || "")}
                    </p>
                    <div className="pt-40 border-top border-neutral-50 mt-40 border-dashed border-0">
                      <button
                        onClick={() =>
                          handleClick(
                            matchedKey === "admission"
                              ? "admissioninfo"
                              : "contactinfo",
                            matchedKey === "admission"
                              ? "/admission"
                              : "/contact",
                          )
                        }
                        className="btn btn-main rounded-pill"
                      >
                        Read More
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {results.map((item, idx) => (
              <div className="col-xl-4 col-md-6" key={idx}>
                <div className="bg-main-25 border border-neutral-30 rounded-12 px-32 py-40 d-flex align-items-start gap-24 transition-2 hover-border-main-600">
                  <div className="flex-grow-1">
                    <div className="flex-align d-inline-flex gap-8 mb-16 wow bounceInDown">
                      <h5 className="text-main-600 mb-0">
                        {truncateWords(item.snippet, 3)}
                      </h5>
                    </div>
                    <h2 className="mb-24 wow bounceInRight">
                      {truncateWords(item.title || item.name || "", 4)}
                    </h2>
                    {item.description && (
                      <p
                        className="text-neutral-500 text-line-2 wow bounceInUp"
                        dangerouslySetInnerHTML={{
                          __html: marked(truncateWords(item.description, 16)),
                        }}
                      ></p>
                    )}
                    {(item.position || item.role) && (
                      <p className="text-neutral-500 text-line-2 wow bounceInUp">
                        {truncateWords(item.position || item.role || "", 16)}
                      </p>
                    )}
                    {item.email && (
                      <p className="text-neutral-500 text-line-2 wow bounceInUp">
                        {truncateWords(item.email || "", 1)}
                      </p>
                    )}
                    {item.phone_number && (
                      <p className="text-neutral-500 text-line-2 wow bounceInUp">
                        {truncateWords(item.phone_number || "", 3)}
                      </p>
                    )}
                    <div className="pt-40 border-top border-neutral-50 mt-40 border-dashed border-0">
                      <button
                        onClick={() =>
                          handleClick(item.section, item.path, item.id)
                        }
                        className="btn btn-main rounded-pill"
                      >
                        Read More
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* <div style={{ padding: "2rem" }}>
        <ul>
          {results.map((item, idx) => (
            <li key={idx}>
              <p>{item.Snippet}</p>
              <strong>{item.Title || item.Name || ""}</strong>
              <br />
              {item.Description || item.Position || item.role || ""}
            </li>
          ))}
        </ul>
      </div> */}
    </>
  );
};

export default SearchSection;
